/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PersonDto } from '../../models/person-dto';
import { SwitchTenantRequest } from '../../models/switch-tenant-request';

export interface SwitchTenant$Params {
      body: SwitchTenantRequest
}

export function switchTenant(http: HttpClient, rootUrl: string, params: SwitchTenant$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonDto>> {
  const rb = new RequestBuilder(rootUrl, switchTenant.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PersonDto>;
    })
  );
}

switchTenant.PATH = '/api/userprofile/switch-tenant';
